export default {
  app: {
    brand: '正佳整蛊游戏'
  },
  nav: {
    home: '首页',
    games: '游戏列表',
    orders: '我的订单',
    coupons: '优惠券',
    recharge: '充值',
    recruit: '主播招募',
    partner: '合作详情',
    faq: '常见问题'
  },
  common: {
    langZh: '简体中文',
    langEn: 'English',
    login: '登录',
    register: '注册',
    registerLogin: '注册/登录',
    balance: '余额',
    guest: '游客模式',
    logout: '退出登录'
  },
  announcement: {
    title: '公告',
    ok: '我知道了'
  },
  home: {
    sectionTitleText: '最热门、最畅销、新发布游戏',
    slogan: '所有游戏支持全平台，提高千万主播直播收入',
    sectionHot: '最热门',
    sectionBest: '最畅销',
    sectionNew: '新发布游戏',
    cardBadge: '全平台',
    viewAll: '查看全部',
    noGames: '暂无游戏',
    title: '数字权益，\n即刻抵达。',
    subtitle: '覆盖抖音、快手、B站、TikTok 与小红书，为创作者和玩家提供透明、稳定的数字商品购买与自动授权服务。',
    joinNow: '了解服务流程',
    viewGames: '探索全部商品',
    metricPlatforms: '主流内容平台支持',
    metricDelivery: '自动交付与授权服务',
    metricTrackValue: '可追踪',
    metricTrack: '订单及售后状态透明',
    feature1Title: '自动交付',
    feature1Desc: '付款完成后自动处理',
    feature2Title: '多平台授权',
    feature2Desc: '覆盖主流直播平台',
    feature3Title: '订单可追踪',
    feature3Desc: '处理状态清晰透明',
    feature4Title: '售后保障',
    feature4Desc: '换绑与异常及时处理',
    sectionTitle: '为稳定交付而设计',
    sectionDesc: '从购买、授权到售后，每个环节都保持清晰、克制，让你专注内容本身。',
    card1Title: '数字商品自动交付',
    card1Desc: '购买完成后自动处理卡密或授权，减少等待与重复沟通。',
    card2Title: '售后与保障',
    card2Desc: '规则清晰、响应及时，合作更安心。',
    card3Title: '公会合作详情',
    card3Desc: '结算透明、对接高效，长期共赢。'
  },
  pages: {
    gamesTitle: '游戏列表',
    gamesDesc: '这里放游戏分类、游戏卡片列表、筛选/搜索等。',
    recruitTitle: '主播招募',
    recruitDesc: '这里放招募条件、合作方式、收益说明等。',
    partnerTitle: '合作详情',
    partnerDesc: '工作室、运营、代理合作详情。',
    faqTitle: '常见问题',
    faqDesc: '这里放常见问题与解答。'
  },
  recruit: {
    introTitle: '正佳直播公会简介',
    introSubtitle: '收入稳定有保障，结算灵活透明，随时可提',
    introBody: '正佳传媒专注于游戏与娱乐直播领域，集主播孵化、内容创新与品牌发展于一体。总部设在山东临沂，业务覆盖国内二十多个省市。我们始终秉承「让直播更轻松、更有趣」的理念，深耕抖音等平台，已形成成熟的招募、培训与变现体系。自有游戏研发团队持续推出整蛊类爆款内容，配合专业运营团队全程陪跑，帮助新老主播稳步提升流水。',
    typesTitle: '招募主播类型',
    typesSubtitle: '自研整蛊游戏内容，入会即可抢先试玩内测玩法，拓宽直播变现渠道。',
    prankGames: '整蛊小游戏',
    gameMario: '马里奥整蛊',
    gameOnlyClimb: 'ONLY CLIMB整蛊',
    gameHalfSword: '半剑整蛊',
    gameGettingOverIt: '掘地求升整蛊',
    gamePeace: '和平精英',
    gameHonor: '王者荣耀',
    gameDelta: '三角洲行动',
    servicesTitle: '我们能为签约主播做什么',
    servicesSubtitle: '运营不满意可申请更换，支持合理解约，全力守护你的直播收益。',
    service1: '独家游戏抢先开播，部分玩法不对外开放',
    service2: '运营团队每周跟进热点玩法与榜单活动',
    service3: '直播间搭建与调试全程免费，问题快速响应',
    service4: '平台官方流量资源倾斜扶持',
    service5: '配备专属运营，提供跟播指导与复盘分析',
    service6: '游戏插件与脚本免费提供，零额外成本',
    service7: '短视频剪辑与素材制作支持',
    service8: '头部主播可定制专属游戏特效与互动玩法'
  },
  partner: {
    title: '工作室、运营、代理合作',
    subtitle: '背靠大树好乘凉，正佳传媒独家资源，一定能帮您多招主播，提高主播流水！'
  },
  faq: {
    searchPh: '搜索问题...',
    noResult: '未找到相关问题，请尝试其他关键词。',
    notFound: '没有找到您的问题？',
    contact: '联系客服',
    contactHint: '请通过合作详情页或订单售后渠道联系客服，并提供订单号以便快速处理。',
    q1: '如何购买游戏？',
    a1: '在游戏列表中选择需要的游戏，点击购买，填写授权平台与账号等信息后完成支付即可。',
    q2: '支持哪些支付方式？',
    a2: '支持微信支付、支付宝及余额支付。',
    q3: '如何换绑账号？',
    a3: '登录后进入「我的订单」，找到对应订单，点击「换绑」按钮并填写新的授权账号即可。',
    q4: '忘记密码怎么办？',
    a4: '当前暂不支持在线找回密码，请联系客服协助处理账号问题。',
    q5: '如何注册账号？',
    a5: '点击页面右上角「登录」，在登录页点击「去注册」填写信息即可完成注册。',
    q6: '订单多久生效？',
    a6: '支付成功后订单即时生效，许可或卡密将自动发放。',
    q7: '可以退款吗？',
    a7: '虚拟商品一经售出一般不支持退款，特殊情况请联系客服处理。'
  },
  auth: {
    loginTitle: '登录',
    loginSub: '欢迎回来，请先登录',
    registerTitle: '注册',
    registerSub: '创建账号开始使用',
    username: '用户名',
    usernamePh: '请输入用户名',
    usernameReq: '请输入用户名',
    password: '密码',
    passwordPh: '请输入密码',
    passwordReq: '请输入密码',
    captcha: '图形验证码',
    captchaPh: '请输入验证码',
    captchaReq: '请输入验证码',
    refreshCaptcha: '点击刷新验证码',
    captchaInvalid: '验证码错误，请重试',
    loginBtn: '登录',
    loginOk: '登录成功',
    loginFailed: '登录失败',
    registerBtn: '注册',
    registerOk: '注册成功，请登录',
    registerFailed: '注册失败',
    noAccount: '没有账号？',
    goRegister: '去注册',
    hasAccount: '已有账号？',
    goLogin: '去登录',
    userExists: '用户名已存在',
    userNotFound: '用户不存在',
    passwordInvalid: '密码错误',
    accountLocked: '登录失败次数过多，请稍后再试',
    rateLimited: '操作过于频繁，请稍后再试',
    passwordTooShort: '密码至少 6 位',
    logoutOk: '已退出登录'
  },
  recharge: {
    title: '账户充值',
    amount: '充值金额',
    payType: '支付方式',
    payMethod: '下单方式',
    methodWeb: '网页支付（可返回二维码/跳转等）',
    methodJump: '跳转支付（仅返回跳转链接）',
    submit: '去支付',
    scanTitle: '请扫码支付',
    scanTip: '支付完成后将自动检测并刷新状态，也可点击下方按钮手动查看。',
    paidGoResult: '我已完成支付',
    payInfo: '支付参数',
    needLogin: '请先登录',
    configMissing: '服务端未配置支付公网地址，请联系管理员配置 PAY_PUBLIC_API_BASE 与 PAY_RETURN_FRONT_BASE。',
    failed: '发起支付失败',
    resultTitle: '充值结果',
    resultSub: '若已付款，余额可能略有延迟；可稍候刷新或返回首页查看储值。',
    polling: '正在查询订单状态…',
    missingOrder: '缺少订单号',
    queryFailed: '查询失败',
    network: '网络异常',
    orderNo: '商户订单号',
    status: '状态',
    platformNo: '平台订单号',
    refresh: '刷新状态',
    backHome: '返回首页',
    stPending: '待支付',
    stPaid: '已到账',
    stFailed: '失败',
    stClosed: '已关闭'
  },
  gamesPurchase: {
    pickGame: '购买',
    dialogTitle: '购买游戏许可',
    dialogTitleCard: '购买卡密',
    dialogTitleZhengjia: '购买正佳授权',
    platform: '授权平台',
    platformPh: '请选择授权平台',
    platformInvalid: '请选择授权平台',
    platformDouyin: '抖音',
    platformKuaishou: '快手',
    platformBilibili: 'B站',
    platformTiktok: 'TikTok',
    platformXiaohongshu: '小红书',
    authorizationAccount: '授权账号',
    authorizationAccountPh: '请输入一个需要授权的平台账号',
    authorizationAccountInvalid: '请输入一个有效的授权账号',
    authorizationAccountMultiple: '授权账号只能填写一个',
    senseyunPhone: '深盾授权账号',
    senseyunPhonePh: '请输入手机号或邮箱',
    phoneInvalid: '请输入正确的深盾授权手机号或邮箱',
    authorizationSection: '授权信息',
    authorizationSectionDesc: '请确认平台账号与深盾授权账号（手机号或邮箱）准确无误',
    authorizationSectionDescSenseyun: '请确认平台账号与深盾授权账号（手机号或邮箱）准确无误',
    authorizationSectionDescCard: '请选择授权平台并填写授权账号，支付成功后即可查看卡密',
    authorizationSectionDescZhengjia: '请选择授权平台并填写授权账号，支付成功后发放正佳授权卡密',
    planSectionDesc: '选择本次许可的有效期',
    paymentSection: '支付信息',
    paymentSectionDesc: '选择支付渠道',
    methodWebFixed: '网页支付',
    cardProduct: '卡密商品',
    licenseProduct: '深盾许可',
    zhengjiaProduct: '正佳授权',
    payAmount: '应付金额',
    descCard: '请选择授权平台并填写授权账号；支付成功后即可查看卡密。',
    cardSecret: '您的卡密',
    planLabel: '套餐',
    planMonth: '月卡',
    planQuarter: '季卡',
    planYear: '年卡',
    retailRef: '零售价 {price}',
    resultPlan: '套餐',
    needLogin: '请先登录',
    needBackend: '请开启后端模式（VUE_APP_USE_BACKEND=true）后再购买。',
    balancePay: '余额支付',
    onlinePay: '在线支付',
    payType: '支付方式',
    payMethod: '下单方式',
    methodWeb: '网页支付（可返回二维码/跳转等）',
    methodJump: '跳转支付（仅返回跳转链接）',
    submitOnline: '去支付',
    successBalance: '购买成功',
    invalidGamePrice: '游戏价格无效，请检查月卡/季卡/年卡价格配置。',
    planUnavailable: '当前游戏未开放该规格，请重新选择。',
    gameNotFound: '未找到该游戏，请确认后台已上架且产品许可 ID 与请求一致。',
    gameOffShelf: '该游戏已下架，暂无法购买。',
    outOfStock: '该游戏库存不足，暂无法购买。',
    licenseMissing:
      '该游戏未配置深盾产品许可。',
    senseyunError: '深盾许可下发失败',
    senseyunLicenseNotFound:
      '深盾产品许可不存在。',
    senseyunUserNotFound:
      '深盾用户不存在，请注册手机号为深盾用户。',
    insufficient: '余额不足',
    debitHint: '许可可能已下发但扣款异常，请凭订单号联系客服处理。',
    resultTitle: '购买订单',
    resultSub: '若已在线支付，许可下发可能略有延迟，可刷新查看状态。',
    polling: '正在查询订单状态…',
    orderNo: '商户订单号',
    status: '状态',
    senseDesc: '深盾说明',
    fulfillmentDesc: '履约说明',
    refresh: '刷新状态',
    close: '关闭',
    stPending: '待支付',
    stPaid: '已完成',
    stFailed: '失败',
    stProcessing: '处理中',
    stLicenseFailed: '已支付但许可失败',
    stClosed: '已关闭',
    configMissing: '服务端未配置支付公网地址，请联系管理员。',
    jumpTip: '正在跳转支付页面…'
  },
  orders: {
    title: '我的订单',
    desc: '查看历史购买记录，已完成订单可在此查询卡密与授权信息。',
    searchPh: '按订单号 / 手机号 / 授权账号搜索',
    refresh: '刷新',
    empty: '暂无订单记录',
    goShop: '去选购游戏',
    needLogin: '请先登录，可使用右上角「登录」查看您的购买订单',
    needBackend: '请开启后端模式（VUE_APP_USE_BACKEND=true）后使用订单查询。',
    loadFailed: '加载订单失败',
    colOrderNo: '订单号',
    colGame: '商品',
    colPlan: '套餐',
    colAmount: '金额',
    colPayChannel: '支付方式',
    colStatus: '状态',
    colCreated: '下单时间',
    colActions: '操作',
    viewDetail: '详情',
    viewCard: '查看卡密',
    detailTitle: '订单详情',
    detailSub: '查看订单状态、授权信息与卡密内容。',
    payBalance: '余额支付',
    payOnline: '在线支付',
    extraAuth: '额外授权',
    extraAuthZhenggu: '整蛊++',
    extraAuthOnly: 'Only++',
    copyCard: '复制卡密',
    retryFulfill: '重新发卡',
    retryFulfillOk: '发卡成功，请查看卡密',
    retryFulfillFail: '发卡仍未成功，请稍后重试或联系客服',
    copyOk: '卡密已复制',
    copyFail: '复制失败，请手动复制',
    rebind: '换绑',
    lock: '锁定',
    lockTitle: '锁定卡密',
    lockSub: '锁定后对应许可或卡密将无法继续使用，请确认后再操作。',
    lockConfirmGame: '确认锁定深盾游戏许可？锁定后将无法继续使用。',
    lockConfirmZhenggu: '确认禁用整蛊++卡密？禁用后将无法登录使用。',
    lockConfirmOnly: '确认禁用 Only++ 卡密？禁用后将无法登录使用。',
    lockConfirmBoth: '确认同时锁定深盾游戏许可并禁用附加授权卡密？锁定后将无法继续使用。',
    lockSubmit: '确认锁定',
    lockCancel: '取消',
    lockOk: '锁定成功',
    lockFailed: '锁定失败',
    lockAgentRequired: '仅代理用户可使用锁定功能',
    lockNotSupported: '该订单暂不支持锁定',
    lockSenseyunFailed: '深盾许可锁定失败',
    lockZhengguFailed: '整蛊++卡密禁用失败',
    unbindMachine: '解绑机器码',
    unbindMachineTitle: '解绑机器码',
    unbindMachineConfirm: '确认解绑该整蛊++卡密当前绑定的机器码？解绑后可在新设备重新登录绑定。',
    unbindMachineSubmit: '确认解绑',
    unbindMachineCancel: '取消',
    unbindMachineOk: '机器码解绑成功',
    unbindMachineOkRemain: '机器码解绑成功，剩余可解绑次数：{count}',
    unbindMachineFailed: '机器码解绑失败',
    unbindMachineAgentRequired: '仅代理用户可解绑机器码',
    unbindMachineNotSupported: '该订单不支持解绑机器码',
    unbindMachineNotReady: '整蛊++解绑接口暂不可用',
    rebindTitle: '订单换绑',
    rebindSub: '选择需要换绑的程序，并按提示填写对应账号信息。不支持跨平台换绑。',
    rebindCurrentAccount: '当前授权账号',
    rebindCurrentAuthAccount: '当前直播授权账号',
    rebindCurrentSenseyunPhone: '当前深盾账号',
    rebindNewAccount: '新直播授权账号',
    rebindNewAccountPh: '请输入一个新的平台直播授权账号',
    rebindNewSenseyunPhone: '新深盾账号',
    rebindNewAccountInvalid: '请输入有效的新直播授权账号',
    rebindSameAccount: '新账号不能与当前账号相同',
    rebindSamePhone: '新账号不能与当前账号相同',
    rebindSubmit: '提交换绑',
    rebindOk: '换绑成功',
    rebindFailed: '换绑失败',
    rebindNotReady: '该订单类型暂不支持换绑',
    rebindNotSupported: '该订单暂不支持换绑',
    rebindUnbindExhausted: '免费解绑次数已用完，无法换绑',
    rebindUnbindTargets: '解绑程序',
    rebindUnbindGame: '游戏授权',
    rebindUnbindZhenggu: '整蛊++',
    rebindUnbindOnly: 'Only++',
    rebindUnbindRequired: '请选择需要换绑的程序',
    rebindSenseyunUnlockFailed: '游戏许可锁定失败',
    rebindSenseyunLockFailed: '游戏许可锁定失败',
    rebindFeeFree: '本次换绑免费（剩余免费次数 {remaining}）',
    rebindFeeUnlimited: '该平台换绑无限次免费',
    rebindFeeCharge: '本次换绑需支付 {fee}',
    rebindFeeChargeBalance: '本次换绑将从余额扣费 {fee}',
    rebindInsufficientBalance: '余额不足，本次换绑需支付 {fee}，可改用在线支付或先充值',
    rebindSenseyunExpired: '深盾手机号仅支持购买后 24 小时内换绑，已超过时限',
    rebindSenseyunRemainLabel: '换绑剩余时间',
    rebindSenseyunRemainValue: '剩余 {time}',
    rebindSenseyunRemainExpired: '已超时，无法换绑',
    rebindPayBalance: '余额支付',
    rebindPayOnline: '在线支付',
    rebindPayChannel: '支付方式',
    rebindOnlineTip: '支付成功后将自动完成换绑'
  },
  coupons: {
    title: '我的优惠券',
    filterAll: '全部',
    filterUnused: '未使用',
    filterUsed: '已使用',
    filterExpired: '已过期',
    empty: '暂无优惠券',
    loadFailed: '加载优惠券失败',
    unnamed: '优惠券',
    validTo: '有效期至',
    scopeAll: '全场可用（无门槛）',
    scopeGame: '指定游戏可用',
    statusUnused: '未使用',
    statusUsed: '已使用',
    statusExpired: '已过期',
    statusLocked: '锁定中',
    select: '优惠券',
    selectNone: '不使用优惠券',
    discount: '已优惠 {amount}',
    payAfter: '券后应付'
  },
  rechargeGift: {
    title: '充值有礼',
    tip: '单笔充值满 {amount} 元，赠送「{coupon}」¥{discount} 优惠券 ×{count}'
  },
  rechargeCashback: {
    title: '充值返现',
    tip: '单笔充值满 {amount} 元，返现 ¥{cashback} 到余额'
  }
}
